import { Dialog } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { AlertOptions, AlertResult } from '../components/alert/alert.type';
import { AlertComponent } from '../components/alert/alert.component';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private readonly dialog = inject(Dialog);

  open(options: AlertOptions) {
    return this.dialog.open<AlertResult>(AlertComponent, {
      maxHeight: '100%',
      data: options,
      disableClose: true,
      ariaModal: true,
      restoreFocus: true,
    });
  }
}
